import React from 'react';
import { Box, InlineStack, TextField, Button, ButtonGroup, Text } from '@shopify/polaris';
import { ChevronDownIcon, ChevronUpIcon, XIcon } from '@shopify/polaris-icons';
import Language from '../../i18n/Language';

const t = Language;

/**
 * 富文本编辑器内的「查找」浮层（Polaris 组件实现）
 * 参考 Figma: node 21413-153515
 * 纯展示组件：输入框展示当前查找文案，右侧展示 当前/总数 及上下定位、关闭按钮。
 */
const EditorFindBar = (props) => {
    const {
        keyword = '',
        current = 0,
        total = 0,
        onNext,
        onPrev,
        onClose,
        onKeywordChange,
    } = props;

    const hasMatch = total > 0;

    return (
        <div className="editor_find_bar">
            <Box background="bg-surface" borderRadius="300" padding="300" shadow="500">
                <InlineStack gap="200" blockAlign="center" align="space-between" wrap={false}>
                    <div className="editor_find_bar_input">
                        <TextField
                            label={t('Find in content')}
                            labelHidden
                            value={keyword}
                            // readOnly={typeof onKeywordChange !== 'function'}
                            onChange={onKeywordChange}
                            autoComplete="off"
                        />
                    </div>

                    <InlineStack gap="400" blockAlign="center" wrap={false}>
                        <Text as="span" variant="bodyMd">
                            {`${hasMatch ? current : 0} / ${total}`}
                        </Text>

                        <ButtonGroup variant="segmented">
                            <Button
                                icon={ChevronUpIcon}
                                onClick={onPrev}
                                disabled={!hasMatch}
                                accessibilityLabel={t('Previous')}
                            />
                            <Button
                                icon={ChevronDownIcon}
                                onClick={onNext}
                                disabled={!hasMatch}
                                accessibilityLabel={t('Next')}
                            />
                        </ButtonGroup>

                        <Button
                            variant="tertiary"
                            icon={XIcon}
                            onClick={onClose}
                            accessibilityLabel={t('Close')}
                        />
                    </InlineStack>
                </InlineStack>
            </Box>
        </div>
    );
};

export default EditorFindBar;
